<div class="usa-modal usa-modal--lg display-flex" id="example-modal-2" aria-labelledby="modal-2-heading" aria-describedby="modal-2-description">
  <div class="usa-modal__content">
    <div class="usa-modal__main padding-y-0 define-width">
      <h2 class="usa-modal__heading pin-center" id="modal-2-heading" *ngIf="itemModalCalledFrom != 'frtBOL'; else notShow">
        Add or Edit Item Information
      </h2>
      <ng-template #notShow>
        <h4 class="modal-title">Item Information</h4>
      </ng-template>
      <div class="usa-prose">
        <div class="grid-row">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <ag-grid-angular
                 style="width: 100%; height: 150px;"
                  class="ag-theme-alpine"
                  [columnDefs]="shipmentPackageColumnDefs"
                  [rowData]="this.shipmentPackageList"
                  [suppressDragLeaveHidesColumns]="true"
                  [paginationPageSize]="4"
                  [pagination]="true">
                </ag-grid-angular>
          </div>
        </div>
        <div class="grid-row" *ngIf="itemModalCalledFrom != 'frtBOL' && false === isCarrierUser">
          <form [formGroup]="frtShipmentItem">
            <div class="grid-row">
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-7 desktop:grid-col-7">
                <ng-template #customItemTemplate let-model="item">{{model.itemNumber}} -
                  {{model.description}}
                </ng-template>
                <label for="OriginSearchString" class="usa-label">Search by Item Type or Description <abbr title="required" class="usa-hint usa-hint--required">*</abbr>: </label>

                <input
                id="OriginSearchString" class="usa-input"
                formControlName="asyncOriginSearchString"
                [typeaheadAsync]="true" [typeahead]="dataSourceOrigin"
                (typeaheadLoading)="changeTypeaheadOriginLoading($event)"
                (typeaheadOnSelect)="typeaheadOriginOnSelect($event)"
                typeaheadOptionField="itemNumber"
                [typeaheadItemTemplate]="customItemTemplate"
                [typeaheadWaitMs]="1000" [typeaheadScrollable]="true"
                [typeaheadOptionsInScrollableView]="10"
                [typeaheadOptionsLimit]="100"
                placeholder="Type a Item Number or description">
              </div>

              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <div class="grid-row grid-gap-1">
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <label for="name" class="usa-label"> Quantity </label>
                     <input id="name" type="text" id="tchName" class="usa-input" formControlName="itemsQuantity" maxlength="5" appNumbersOnly
                     onkeypress="return !(event.charCode == 46)" step="1">
                  </div>

                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <label for="type" class="usa-label"> Weight </label>
                     <input id="type" type="text" id="pkggrp" class="usa-input" formControlName="itemsWeight" maxlength="5" appNumbersOnly
                     onkeypress="return !(event.charCode == 46)" step="1">
                  </div>

                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <label for="description" class="usa-label"> Other Description</label>
                     <input id="description" type="text" id="psn" class="usa-input" formControlName="otherDescription">
                  </div>

                </div>
              </div>
            </div>
            <div class="grid-row" *ngIf="itemModalCalledFrom != 'frtBOL' && false === isCarrierUser">
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <ul class="usa-button-group">
                  <li class="usa-button-group__item">
                    <button type="button" class="usa-button" [disabled]="(!(frtShipmentItem.valid && !itemClicked)) || this.isUserFromCarrierOrBOL" (click)="addItems()">Add</button>
                  </li>
                  <li class="usa-button-group__item">
                    <button type="button" class="usa-button" [disabled]="(!(frtShipmentItem.valid && itemClicked)) || this.isUserFromCarrierOrBOL" (click)="updateItem()">Update</button>
                  </li>
                  <li class="usa-button-group__item">
                    <button type="button" class="usa-button usa-button--secondary" [disabled]="(!itemClicked) || this.isUserFromCarrierOrBOL" (click)="deleteItem()">Delete</button>
                  </li>
                  <li class="usa-button-group__item">
                    <button type="button" class="usa-button usa-button--secondary" [disabled]="(!(frtShipmentItem.touched || frtShipmentItem.dirty || itemClicked)) || this.isUserFromCarrierOrBOL" (click)="reset()">Reset</button>
                  </li>
                </ul>
              </div>

            </div>
          </form>
        </div>
        <div class="grid-row">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="itemModalCalledFrom != 'frtBOL' && false === isCarrierUser">
            click on the "Type" link from the list below to edit the item information
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <ag-grid-angular
                class="ag-theme-alpine"
                style="width: 100%; height: 130px;"
                [gridOptions]="shipmentItemGridOptions"
                [rowData]="this.shipmentItemListBeforeEditFields"
                [suppressDragLeaveHidesColumns]="true"
                [paginationPageSize]="4"
                [pagination]="true">
              </ag-grid-angular>
          </div>
        </div>

      </div>
      <div class="usa-modal__footer define-float">
          <button type="button"  *ngIf="itemModalCalledFrom != 'frtBOL'; else notShowClose" class="usa-button" (click)="closeModal()">Continue</button>
          </div>
          <ng-template #notShowClose>
              <button type="button"  class="usa-button" (click)="closeModal()">Close</button>
          </ng-template>
    </div>
    <button type="button" class="usa-button usa-modal__close" aria-label="Close this window" data-close-modal (click)="closeModal()">
    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
      <use xlink:href="/assets/uswds/img/sprite.svg#close"></use>
    </svg>
  </button>

  </div>
</div>

<!-- <div class="modal-header">
  <h4 class="modal-title"  *ngIf="itemModalCalledFrom != 'frtBOL'; else notShow">Add or Edit Item Information</h4>
  <ng-template #notShow>
    <h4 class="modal-title">Item Information</h4>
  </ng-template>
</div>
<div class="modal-body grid-container">
  <div class="grid-row" *ngIf="this.shipmentPackageList.length>0">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      <ag-grid-angular
        class="ag-theme-alpine itemModalShipmentPackageGrid"
        [gridOptions]="shipmentPackageGridOptions"
        [rowData]="shipmentPackageList"
        [suppressDragLeaveHidesColumns]="true">
      </ag-grid-angular>
    </div>
  </div>
  <div class="grid-row" *ngIf="itemModalCalledFrom != 'frtBOL' && false === isCarrierUser">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      <form [formGroup]="frtShipmentItem">
        <div class="grid-row">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
            <ng-template #customItemTemplate let-model="item">{{model.itemNumber}} -
              {{model.description}}
            </ng-template>
            <label for="OriginSearchString" class="usa-label">Search by Item Type or Description: </label>
            <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
            <input
            id="OriginSearchString" class="usa-input"
            formControlName="asyncOriginSearchString"
            [typeaheadAsync]="true" [typeahead]="dataSourceOrigin"
            (typeaheadLoading)="changeTypeaheadOriginLoading($event)"
            (typeaheadOnSelect)="typeaheadOriginOnSelect($event)"
            typeaheadOptionField="itemNumber"
            [typeaheadItemTemplate]="customItemTemplate"
            [typeaheadWaitMs]="1000" [typeaheadScrollable]="true"
            [typeaheadOptionsInScrollableView]="10"
            [typeaheadOptionsLimit]="100"
            placeholder="Type a Item Number or description">
          </div>

          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <div class="grid-row grid-gap-1">
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label for="name" class="usa-label"> Quantity </label>
                 <input type="text" id="tchName" class="usa-input" formControlName="itemsQuantity" maxlength="5" appNumbersOnly
                 onkeypress="return !(event.charCode == 46)" step="1">
              </div>

              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label for="type" class="usa-label"> Weight </label>
                 <input type="text" id="pkggrp" class="usa-input" formControlName="itemsWeight" maxlength="5" appNumbersOnly
                 onkeypress="return !(event.charCode == 46)" step="1">
              </div>

              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label for="description" class="usa-label"> Other Description</label>
                 <input type="text" id="psn" class="usa-input" formControlName="otherDescription">
              </div>

            </div>
          </div>
        </div>
        <div class="grid-row" *ngIf="itemModalCalledFrom != 'frtBOL' && false === isCarrierUser">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <ul class="usa-button-group">
              <li class="usa-button-group__item">
                <button type="button" class="btn btn-primary w-auto mr-4" [disabled]="(!(frtShipmentItem.valid && !itemClicked)) || this.isUserFromCarrierOrBOL" (click)="addItems()">Add</button>
              </li>
              <li class="usa-button-group__item">
                <button type="button" class="btn btn-primary w-auto mr-4" [disabled]="(!(frtShipmentItem.valid && itemClicked)) || this.isUserFromCarrierOrBOL" (click)="updateItem()">Update</button>
              </li>
              <li class="usa-button-group__item">
                <button type="button" class="btn btn-primary w-auto mr-4" [disabled]="(!itemClicked) || this.isUserFromCarrierOrBOL" (click)="deleteItem()">Delete</button>
              </li>
              <li class="usa-button-group__item">
                <button type="button" class="btn btn-danger w-auto mr-4" [disabled]="(!(frtShipmentItem.touched || frtShipmentItem.dirty || itemClicked)) || this.isUserFromCarrierOrBOL" (click)="reset()">Reset</button>
              </li>
            </ul>
          </div>

        </div>
      </form>
    </div>

  </div>
  <div class="grid-row">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="itemModalCalledFrom != 'frtBOL' && false === isCarrierUser">
      click on the "Type" link from the list below to edit the item information
    </div>
  </div>
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
    <ag-grid-angular
        class="ag-theme-alpine itemModalShipmentItemGrid"
        [gridOptions]="shipmentItemGridOptions"
        [rowData]="shipmentItemListBeforeEditFields"
        [suppressDragLeaveHidesColumns]="true">
      </ag-grid-angular>
  </div>
</div>
<div class="modal-footer">
  <div class="center-block">
  <button type="button"  *ngIf="itemModalCalledFrom != 'frtBOL'; else notShowClose" class="btn btn-primary w-auto mr-4" (click)="closeModal()">Continue</button>
  </div>
  <ng-template #notShowClose>
      <button type="button"  class="btn btn-primary" (click)="closeModal()">Close</button>
  </ng-template>
</div> -->
<!--

<div class="modal-header">
  <h5 *ngIf="itemModalCalledFrom != 'frtBOL'; else notShow" class="frt-item-header">Add or Edit Item Information</h5>
  <ng-template #notShow>
        <h5 class="frt-item-header">Item Information</h5>
  </ng-template>
</div>
<div class="modal-body">
  <div class="container-fluid py-5">
    <ag-grid-angular
      class="ag-theme-alpine itemModalShipmentPackageGrid"
      [gridOptions]="shipmentPackageGridOptions"
      [rowData]="shipmentPackageList"
      [suppressDragLeaveHidesColumns]="true">
    </ag-grid-angular>
  </div>
  <div class="py-5 px-4" *ngIf="itemModalCalledFrom != 'frtBOL' && false === isCarrierUser">
    <div>
      <form [formGroup]="frtShipmentItem">
         <div class="form-row pt-2">
           <div class="form-group col-md-4">
              <ng-template #customItemTemplate let-model="item">{{model.itemNumber}} -
                {{model.description}}
              </ng-template>
              <label for="OriginSearchString">Search by Item Type or Description: </label>
              <small class="bol-info-required">*</small>
              <input
              id="OriginSearchString" class="w-100"
              formControlName="asyncOriginSearchString"
              [typeaheadAsync]="true" [typeahead]="dataSourceOrigin"
              (typeaheadLoading)="changeTypeaheadOriginLoading($event)"
              (typeaheadOnSelect)="typeaheadOriginOnSelect($event)"
              typeaheadOptionField="itemNumber"
              [typeaheadItemTemplate]="customItemTemplate"
              [typeaheadWaitMs]="1000" [typeaheadScrollable]="true"
              [typeaheadOptionsInScrollableView]="10"
              [typeaheadOptionsLimit]="100"
              placeholder="Type a Item Number or description">

            </div>
            <div class="col-md-2">
               <label for="name" class="noMarginLeft">
                Quantity
               </label>
               <input type="text" id="tchName" class="w-100" formControlName="itemsQuantity" maxlength="5" appNumbersOnly
               onkeypress="return !(event.charCode == 46)" step="1">
            </div>
            <div class="col-md-2">
              <label for="type" class="noMarginLeft">
               Weight
              </label>
              <input type="text" id="pkggrp" class="w-100" formControlName="itemsWeight" maxlength="5" appNumbersOnly
              onkeypress="return !(event.charCode == 46)" step="1">
           </div>
           <div class="col-md-4">
            <label for="description" class="noMarginLeft">
             Other Description
            </label>
            <input type="text" id="psn" class="w-100" formControlName="otherDescription">
           </div>
         </div>
      </form>
   </div>
  </div>
  <div class="row" *ngIf="itemModalCalledFrom != 'frtBOL' && false === isCarrierUser">
    <div class="center-block">
      <button type="button" class="btn btn-primary w-auto mr-4" [disabled]="(!(frtShipmentItem.valid && !itemClicked)) || this.isUserFromCarrierOrBOL" (click)="addItems()">Add</button>
      <button type="button" class="btn btn-primary w-auto mr-4" [disabled]="(!(frtShipmentItem.valid && itemClicked)) || this.isUserFromCarrierOrBOL" (click)="updateItem()">Update</button>
      <button type="button" class="btn btn-primary w-auto mr-4" [disabled]="(!itemClicked) || this.isUserFromCarrierOrBOL" (click)="deleteItem()">Delete</button>
      <button type="button" class="btn btn-danger w-auto mr-4" [disabled]="(!(frtShipmentItem.touched || frtShipmentItem.dirty || itemClicked)) || this.isUserFromCarrierOrBOL" (click)="reset()">Reset</button>
    </div>
  </div>


  <div class="py-3">
    <div class="row" *ngIf="itemModalCalledFrom != 'frtBOL' && false === isCarrierUser">
      <span class="col-md-offset-4">click on the "Type" link from the list below to edit the item information</span>
    </div>
  </div>
  <div class="container-fluid">
      <ag-grid-angular
        class="ag-theme-alpine itemModalShipmentItemGrid"
        [gridOptions]="shipmentItemGridOptions"
        [rowData]="shipmentItemListBeforeEditFields"
        [suppressDragLeaveHidesColumns]="true">
      </ag-grid-angular>
    </div>

</div>
<div class="modal-footer">
    <div class="center-block">
    <button type="button"  *ngIf="itemModalCalledFrom != 'frtBOL'; else notShowClose" class="btn btn-primary w-auto mr-4" (click)="closeModal()">Continue</button>
    </div>
    <ng-template #notShowClose>
        <button type="button"  class="btn btn-primary" (click)="closeModal()">Close</button>
    </ng-template>
  </div> -->
